
    // document ready
$(function(){
    lteIE9 = window.lteIE9;
    if (!lteIE9) {
        var url = location.hostname;
        var storeName = url.split(".");
        storeName = storeName[1];
        

        elementID = getRandomInt(1000,10000);

        switch (storeName) {
            case "12tomatoes":
                var collectionHandle = ('12t-recommended').toLowerCase();
                var storeTag = ("12 tomatoes").toLowerCase();
                break;
            case "theanimalrescuesite":
                var collectionHandle = ('ars-recommended').toLowerCase();
                var storeTag = ("the animal rescue site").toLowerCase();
                break;
            case "greatergood":
                var collectionHandle = ('gg-recommended').toLowerCase();
                var storeTag = ("greatergood").toLowerCase();
            default:
                var collectionHandle = ('gg-recommended').toLowerCase();
                var storeTag = ("greatergood").toLowerCase();
                break;
        }

        
        createRelatedProducts(collectionHandle, storeTag, 1, 50, 4, elementID);
    }
});


function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function addToArray(nameOfArray, element) {
    nameOfArray.push(element);
}

function setMinHeight(element) {
    var elementWidth = $(element).width();
    $(element).animate({"min-height":elementWidth+"px"}, {easing: "swing", duration: 300});
}

function generateProductBlocks(maxFilteredResults, relatedProdWrapper) {
    
    var numProdBlocks = maxFilteredResults;
    var relatedProdWrapper = relatedProdWrapper;

    for (i=0 ; i < numProdBlocks; i++) {
        
        var num = i+1;

        
        var productBlockFrag = document.createDocumentFragment();

        
        var productBlock = document.createElement("div");
        productBlockFrag.appendChild(productBlock);

        
        $(productBlock).attr("id", "gg_related_product_block-" + (i + 1)).addClass("gg-related-product-block-" + num + " gg_related_product_block product-block flex column max-cols-4 min-cols-2");

        
        var prodImg = document.createElement("img");
        $(prodImg).addClass("gg-related-product-block__image gg-related-product-block__image-" + num);
        productBlock.appendChild(prodImg);

        
        $(prodImg).wrap("<div class='gg-related-product-block__image-wrapper image'><div class='inner'></div></div>");
        $(prodImg).wrap("<a class='gg-related-product-block__image-link-" + num +"'></a>");
        var prodTitle = document.createElement("span");
        $(prodTitle).text("Loading…").addClass("gg-related-product-block__title-" + num + " title ftc");
        var prodTextWrapper = document.createElement("div");
        $(prodTextWrapper).attr("id", "gg_related_product_block__text-wrapper-"  + (i + 1)).addClass("gg-related-product-block__text-wrapper ftr");
        $(prodTextWrapper).wrap("<div></div>");
        prodTextWrapper.appendChild(prodTitle);
        $(prodTitle).wrap("<a class='gg-related-product-block__title-link-" + num +"'></a>");
        productBlock.appendChild(prodTextWrapper);

        
        var prodPriceWrapper = document.createElement("div");
        $(prodPriceWrapper).attr("id", "gg_related_product_block__price-wrapper-" + num).addClass("gg-related-product-block__price-wrapper-" + num + " price ftc");
        var prodPrice = document.createElement("span");
        prodPriceWrapper.appendChild(prodPrice);
        $(prodPrice).addClass("gg-related-product-block__price-" + num + " gg-related-product-block__price amount animated-background");
        var prodCompareAtPrice = document.createElement("del");
        prodPriceWrapper.appendChild(prodCompareAtPrice);
        $(prodCompareAtPrice).addClass("gg-related-product-block__compare-at-price-" + num + " gg-related-product-block__compare-at-price");

        
        prodTextWrapper.appendChild(prodPriceWrapper);

        
        relatedProdWrapper.appendChild(productBlockFrag);

        $(productBlock).animate({opacity: 1});

        

    }
}

function updateProductBlocks(filteredProductResults, elementID){
    var matchingProds = filteredProductResults;
    var matchingProdsLength = filteredProductResults.length;
    for (i=0 ; i < matchingProdsLength; i++) {
        var num = i+1;
        var parentEl = ".gg-related-products_section-" + elementID;
        var currentProd = matchingProds[i];

        
        var featuredImage = currentProd.variants[0].featured_image;
        if (featuredImage != null){
            imageSrc = currentProd.variants[0].featured_image.src;
        }
        else {
            imageSrc = currentProd.images[0].src;
        }
        
        var urlFirstPart = imageSrc.split(".");
        var urlLastPart = urlFirstPart[3];
        urlFirstPart = urlFirstPart[0] + "." + urlFirstPart[1] + "." + urlFirstPart[2];
        var newSrc = urlFirstPart + "_1x." + urlLastPart;
        var newSrcSet = urlFirstPart + "_150x." + urlLastPart + " 150w," + urlFirstPart + "_300x." + urlLastPart + " 300w";
        var prodBlockImage = $(parentEl +" .gg-related-product-block__image-" + num);
        $(prodBlockImage).addClass("blur-up lazyload").attr({src: newSrc, alt: currentProd.title, srcset: newSrcSet}).animate({opacity: 1});
        
        var imageLink = $(parentEl + " .gg-related-product-block__image-link-"+ num);
        var titleLink = $(parentEl + " .gg-related-product-block__title-link-"+ num);
        imageLink.attr("href", currentProd.handle);
        titleLink.attr("href", currentProd.handle);
        var prodTitle = ".gg-related-product-block__title-"+ num;
        $(prodTitle).html(currentProd.title);
        var prodPrice = $(parentEl + " .gg-related-product-block__price-" + num);
        prodPrice.removeClass("animated-background");
        $(prodPrice).text(Shopify.formatMoney(currentProd.variants[0].price));
        
        
        var prodPriceWrapper = $(parentEl + " .gg-related-product-block__price-wrapper-" + num);
        if (currentProd.variants.length > 1) {
            $(prodPriceWrapper).prepend("<span class='from'>From</span>");
        }

        
        var compareAtPrice = currentProd.variants[0].compare_at_price;
        if (compareAtPrice != null){
            var prodCompareAtPrice = $(parentEl + " .gg-related-product-block__compare-at-price-"+ num);
            $(prodCompareAtPrice).text(Shopify.formatMoney(compareAtPrice));
            $(prodPriceWrapper).addClass("on-sale");
        }
        setMinHeight(".gg-related-product-block__image-wrapper");
        
    }
}

function getCurrentProdHandle() {
    var currentPageUrl = location.pathname.split("/");
    var currentProdHandle = currentPageUrl[currentPageUrl.length - 1];
    
    return currentProdHandle;
}

function pickRandomItem(array) {
    var randomItem = array[Math.floor(Math.random() * array.length)];
    return randomItem;
}

function createRelatedProducts(collectionHandle, storeTag, resultsPageNum, numOfReturned, maxFilteredResults, elementID) {
    
    
    var relatedProductFrag = document.createDocumentFragment();

    
    var relatedProductSection = document.createElement("section");
    $(relatedProductSection).attr("id", "gg_related_products__section-" + elementID).addClass("gg-related-products_section-" + elementID + " gg-related-products_section border-top section products-section");
    relatedProductFrag.appendChild(relatedProductSection);

    
    var relatedContainer = document.createElement("div");
    $(relatedContainer).attr("id", "gg_related_products__container").addClass("gg-related-products_container container");
    relatedProductSection.appendChild(relatedContainer);
      
    
	var blueCoreRelatedContainer = document.createElement("div");
	$(blueCoreRelatedContainer).attr("id", "gg-bc_related_products__container_2");
	relatedProductSection.appendChild(blueCoreRelatedContainer);

    
    var titleAndLinkWrapper = document.createElement("div");
    $(titleAndLinkWrapper).attr("id", "gg_related_products__opposing-items").addClass("gg-related-products_opposing-items opposing-items");
    relatedContainer.appendChild(titleAndLinkWrapper);

    
    var relatedTitle = "Gathering recommendations…";
    var relatedProdTitle = document.createElement("h1");
    $(relatedProdTitle).attr("id","gg_related_products__title").addClass("gg-related-products_title section-heading left").text(relatedTitle);
    titleAndLinkWrapper.appendChild(relatedProdTitle);

    
    var viewAllHref = "/collections/" + collectionHandle;
    var viewAllBtn = document.createElement("a");
    $(viewAllBtn).attr({id: "gg_related_products__view-all", href: viewAllHref}).addClass("gg-related-products_view-all btn section-count alt").text("View all");
    titleAndLinkWrapper.appendChild(viewAllBtn);

    
    relatedContainer.appendChild(titleAndLinkWrapper);

    
    var relatedProductWrapper = document.createElement("div");
    $(relatedProductWrapper).attr("id","gg_related_products__wrapper").addClass("gg-related-products_wrapper row grid one-row");
    relatedProductWrapper.setAttribute("data-normheights", ".image");
    relatedProductWrapper.setAttribute("data-normheights-inner", "img");
    relatedContainer.appendChild(relatedProductWrapper);

    
    $("#sub-content").length ? $("#sub-content").prepend(relatedProductFrag) : $(relatedProductFrag).insertAfter(".product-description");

    
    generateProductBlocks(maxFilteredResults, relatedProductWrapper);

    
    var collectionTitleRequestURL = '/collections/' + collectionHandle + '.json';
    var collectionTitleRequest = new XMLHttpRequest();
    collectionTitleRequest.open('GET', collectionTitleRequestURL);
    collectionTitleRequest.responseType = 'json';
    collectionTitleRequest.send();

    collectionTitleRequest.onload = function() {
        
        if (typeof collectionTitleRequest.response === "string"){
            
            collectionTitleRequest = JSON.parse(collectionTitleRequest.response);
             
            var collectionTitle = collectionTitleRequest.collection.title;
        }
        else {
            var collectionTitle = collectionTitleRequest.response.collection.title;
        }
        
        
        $(relatedProdTitle).text(collectionTitle);
    }

    
    var productsRequestURL = '/collections/' + collectionHandle + '/products.json?page='+ resultsPageNum +'&limit=' + numOfReturned;
    var productsRequest = new XMLHttpRequest();
    productsRequest.open('GET', productsRequestURL);
    productsRequest.responseType = 'json';
    productsRequest.send();

    productsRequest.onload = function() {
        
        if (typeof productsRequest.response === "string"){
            
            productsRequest = JSON.parse(productsRequest.response);
             
            var returnedProducts = productsRequest.products;
            
        }
        else {
            var returnedProducts = productsRequest.response.products;
            
        }
        
        filterReturnedResults(storeTag, returnedProducts, collectionHandle, maxFilteredResults);
    }
}

function filterReturnedResults(storeTag, arrayOfProducts, collectionHandle, maxNumOfProducts) {
    var matchesArray = [], filteredMatchesArray = [], finalMatchesArray = [];
    var numOfProdInArray = arrayOfProducts.length;
    var currentProductHandle = getCurrentProdHandle();
    for (i=0; i < numOfProdInArray; i++){
        var currentProduct = arrayOfProducts[i];
        var numOfTags = currentProduct.tags.length;
        var available = false;
        var isPromo = false;
        for (j=0; j < numOfTags; j++) {
            var currentTag = currentProduct.tags[j].toLowerCase();
            if (currentTag == storeTag) {
                var numOfVariants = currentProduct.variants.length;
                if (currentProduct.handle != currentProductHandle){
                    for (k=0; k < numOfVariants; k++) {
                        var currentVariant = currentProduct.variants[k];
                        if (currentVariant.available == true) {
                            available = true;
                        }
                    }
                }
            }
            if (currentTag == "promo") {
                isPromo = true;
            }
        }
        
        
        
        if (available && !isPromo) {
            addToArray(filteredMatchesArray, currentProduct);
        }
    }

    var numOfFilteredMatches = filteredMatchesArray.length;
    
    var filteredMatches = 0;
    for (l=0; l < numOfFilteredMatches; l++) {
        if (filteredMatches < maxNumOfProducts) {
            currentProduct = pickRandomItem(filteredMatchesArray);
            if(!(finalMatchesArray.includes(currentProduct))) {
                addToArray(finalMatchesArray, currentProduct);
                filteredMatches++;
                
            }
            
            else {
                l--;
            }
        }
    }
    
    
    updateProductBlocks(finalMatchesArray, elementID);
}


